import history from '../History';

export const nav = (location: string): void => {
  history.push(location);
};
